if (!customElements.get('search-trend-products')) {
  class SearchTrendProducts extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('[data-search-trends]');
      this.terms = (this.dataset.terms || '')
        .split('|')
        .map(term => term.trim())
        .filter(Boolean);

      if (!this.container || this.terms.length === 0) return;

      this.renderTrends();
    }

    async renderTrends() {
      const cards = await Promise.all(
        this.terms.map(term => this.fetchTrendCard(term))
      );

      this.container.innerHTML = cards.join('');
    }

    async fetchTrendCard(term) {
      try {
        const response = await fetch(
          `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=1`
        );

        if (!response.ok) throw new Error(response.status);

        const data = await response.json();
        const product = data?.resources?.results?.products?.[0];

        if (!product) return this.renderTextCard(term);

        const image = this.getImageUrl(product.image);
        const title = product.title || term;
        const url = product.url || `${window.Shopify.routes.root}search?q=${encodeURIComponent(term)}`;

        return this.renderProductCard({ title, url, image });
      } catch (error) {
        return this.renderTextCard(term);
      }
    }

    getImageUrl(image) {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.url || image.src || '';
    }

    renderTextCard(term) {
      const title = this.escapeHTML(term);
      const url = `${window.Shopify.routes.root}search?q=${encodeURIComponent(term)}`;

      return `<a class="search-drawer__trend-fallback" href="${url}">${title}</a>`;
    }

    renderProductCard(product) {
      const image = product.image
        ? `<span class="search-drawer__product-media"><img src="${this.escapeAttribute(product.image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy"></span>`
        : '<span class="search-drawer__product-media"></span>';

      return `
        <a class="search-drawer__product-card" href="${this.escapeAttribute(product.url)}">
          ${image}
          <p class="search-drawer__product-title">${this.escapeHTML(product.title)}</p>
        </a>
      `;
    }

    escapeHTML(value) {
      const div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    escapeAttribute(value) {
      return this.escapeHTML(value).replace(/"/g, '&quot;');
    }
  }

  customElements.define('search-trend-products', SearchTrendProducts);
}

if (!customElements.get('search-recent-products')) {
  class SearchRecentProducts extends HTMLElement {
    constructor() {
      super();

      this.container = this.querySelector('[data-recent-products]');
      this.clearButton = this.querySelector('[data-clear-recent]');

      this.clearButton?.addEventListener('click', () => {
        localStorage.removeItem('recently-viewed');
        this.renderEmpty();
      });

      if (!this.container) return;

      this.renderRecentProducts();
    }

    async renderRecentProducts() {
      const handles = this.getHandles();

      if (handles.length === 0) {
        this.renderEmpty();
        return;
      }

      const products = (
        await Promise.all(handles.map(handle => this.fetchProduct(handle)))
      ).filter(Boolean);

      if (products.length === 0) {
        this.renderEmpty();
        return;
      }

      this.clearButton.hidden = false;
      this.container.innerHTML = products
        .slice(0, 5)
        .map(product => this.renderProductCard(product))
        .join('');
    }

    getHandles() {
      return (localStorage.getItem('recently-viewed') || '')
        .split(',')
        .map(handle => handle.trim())
        .filter(Boolean);
    }

    async fetchProduct(handle) {
      try {
        const response = await fetch(
          `${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`
        );

        if (!response.ok) throw new Error(response.status);

        return await response.json();
      } catch (error) {
        return null;
      }
    }

    renderEmpty() {
      this.clearButton.hidden = true;
      this.container.innerHTML = '<p class="search-drawer__empty">Recently viewed products will appear here.</p>';
    }

    renderProductCard(product) {
      const image = product.featured_image
        ? `<span class="search-drawer__product-media"><img src="${this.escapeAttribute(product.featured_image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy"></span>`
        : '<span class="search-drawer__product-media"></span>';

      return `
        <a class="search-drawer__product-card" href="${this.escapeAttribute(product.url)}">
          ${image}
          <p class="search-drawer__product-title">${this.escapeHTML(product.title)}</p>
          <p class="search-drawer__product-price">${this.formatMoney(product.price)}</p>
        </a>
      `;
    }

    formatMoney(cents) {
      const currency = window.Shopify?.currency?.active || 'CAD';

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency
      }).format((Number(cents) || 0) / 100);
    }

    escapeHTML(value) {
      const div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }

    escapeAttribute(value) {
      return this.escapeHTML(value).replace(/"/g, '&quot;');
    }
  }

  customElements.define('search-recent-products', SearchRecentProducts);
}
